import EmberObject from '@ember/object';
import Route from 'mewe/routes/route';
import GroupPublicStore from 'mewe/stores/group-public-store';

export default Route.extend({
  model(params) {
    // try fetching public group by groupId
    // if it fails then will redirect to 404 (or homepage if not logged in)
    // if works then will move to public page with proper publicId
    if (params.group_public_id.indexOf('id=') !== -1) {
      this.dispatch('public-pages', 'fetchPublicGroupById', params.group_public_id.slice(3));
      return {};
    }

    this.dispatch('public-pages', 'fetchPublicGroupByPublicId', params.group_public_id);

    return EmberObject.create({
      group: GroupPublicStore.getState({ publicId: params.group_public_id }),
      groupPublicId: params.group_public_id,
      email: params.email,
      invitationId: params.inId,
      context: params.context,
    });
  },
});
